export default "__VITE_ASSET__DwGqn96X__"